import { LOGIN, LOGOUT, GETPROFILE, GET2FACODE} from "../action";

const AuthReducer = (state: any, action: any) => {
    switch(action.type){
        case LOGIN:
            localStorage.setItem("user", JSON.stringify(action.payload))
            localStorage.setItem("accessToken", JSON.stringify(action.payload.accessToken))
            localStorage.setItem("refreshToken", JSON.stringify(action.payload.refreshToken))
            return {
                ...state,
                accessToken: action.payload.accessToken,
                refreshToken: action.payload.refreshToken,
                isAuthenticated: true,
                isLoading: true,
                user: action.payload.username,
                userobj: action.payload
            }
        case LOGOUT:
            localStorage.removeItem("user")
            localStorage.removeItem("accessToken")
            localStorage.removeItem("refreshToken")

            return {
                accessToken: "",
                refreshToken: "",
                getProfileData: null,
                isAuthenticated: false,
                isLoading: true,
                user: null,
                userobj: null
            }
        case GETPROFILE:
            return {
                ...state,
                getProfileData: action.payload
            }

        case GET2FACODE:
            return{
                ...state,
                secretToken: action.payload.secretToken,
                otpAuthUrl: action.payload.otpAuthUrl
            }
        default:
            return state;
    }
}

export default AuthReducer;